module.exports = __webpack_public_path__ + "static/media/YB5F06_1.70a81b9b.jpg";